export const DEFAULT_STOREY_IMAGE_TRANSPARENCY_CONFIG: StoreyImageTransparencyConfig = {
  '2D': { foreground: 70, background: 70 },
  '3D': { foreground: 0, background: 80 },
}

/** Default horizontal width (cm) when using custom ("Andere") paper format — A1 long edge. */
export const DEFAULT_CUSTOM_PAPER_WIDTH_CM = 84.1

export const CUSTOM_STOREY_IMAGE_PAPER_FORMAT = 'custom' as const

export const DEFAULT_STOREY_UPLOAD_IMAGE_CONFIG: StoreyImageTransform = {
  scale: 100,
  offsetX: 0,
  offsetY: 0,
  offsetsInPdfCm: true,
  rotation: 0,
  transparencyConfig: DEFAULT_STOREY_IMAGE_TRANSPARENCY_CONFIG,
  paperFormat: 'A1',
  paperWidthCm: DEFAULT_CUSTOM_PAPER_WIDTH_CM,
}

export const pdfCmOffsetToWorldMeters = (pdfCm: number, scale: number): number =>
  (pdfCm / 100) * scale

export const worldMetersToPdfCmOffset = (meters: number, scale: number): number =>
  (meters * 100) / scale

export const normalizeStoreyImageTransform = (
  transform: StoreyImageTransform,
): StoreyImageTransform => {
  if (transform.offsetsInPdfCm) {
    return transform
  }

  const scale = transform.scale || 100
  return {
    ...transform,
    offsetX: (transform.offsetX * 100) / scale,
    offsetY: (transform.offsetY * 100) / scale,
  }
}
